import React from "react";

import "./title.scss";

const Title = ({ children }) => <h1 className="Title">{children}</h1>;

export default Title;
